/**
 * Generative-UI spike — the JSON UI spec contract.
 *
 * An agent returns a UISpec (a tree of catalog components) instead of, or
 * alongside, text. The client renders it inline in the chat from a FIXED catalog
 * (catalog.tsx) — unknown components are safely ignored. This is the json-render
 * model: AI → constrained JSON → UI. (json-render would replace JsonRenderer.tsx
 * with its catalog/schema engine; the spec + chat plumbing stay the same.)
 */
export interface UISpec {
  /** Component name — must exist in the catalog, else it renders a safe fallback. */
  type: string;
  props?: Record<string, any>;
  children?: UISpec[];
}

/** A canned "agent response" used by the spike to prove the loop end-to-end. */
export const SAMPLE_PROJECT_STATUS: UISpec = {
  type: 'Stack',
  children: [
    {
      type: 'Card',
      props: { title: 'Project status — Mobile App MVP' },
      children: [
        {
          type: 'StatGroup',
          children: [
            { type: 'Stat', props: { label: 'Tasks done', value: '12 / 18', delta: '+3 this week', tone: 'good' } },
            { type: 'Stat', props: { label: 'Sprint', value: 'Sprint 2', delta: '5 days left' } },
            { type: 'Stat', props: { label: 'AI credits', value: '420', delta: 'of 500', tone: 'warn' } },
          ],
        },
        {
          type: 'TaskList',
          props: {
            title: 'Up next',
            items: [
              { title: 'Wire auth screens', status: 'in_progress' },
              { title: 'Design onboarding flow', status: 'todo' },
              { title: 'Set up CI', status: 'done' },
            ],
          },
        },
        { type: 'Button', props: { label: 'Open task board', action: 'open_board', variant: 'primary' } },
      ],
    },
  ],
};
